import BaseSelector from '@src/components/BaseSelector';
import { useUserSelector } from './hooks/useUserSelector';

export const UserSelector = ({
  onChange,
  value = [],
  divisionIds = [],
  orgId,
  userIds = [],
  pageSize = 10,
  exactMatch = false,
  showAllOption = false,
  allLabelId = 'general.all',
  allValue = [],
}) => {
  const { items, loading, handlePopupScroll, search, reset } = useUserSelector({
    divisionIds,
    orgId,
    userIds,
    pageSize,
    exactMatch,
  });

  return (
    <BaseSelector
      allLabelId={allLabelId}
      allValue={allValue}
      items={items}
      loading={loading}
      handlePopupScroll={handlePopupScroll}
      onSearch={search}
      onReset={reset}
      value={value}
      onChange={onChange}
      mode="multiple"
      getItemName={item =>
        item?.firstName && item?.lastName ? `${item.firstName} ${item.lastName}` : item?.email || ''
      }
      getItemId={item => item.id}
      showAllOption={showAllOption}
    />
  );
};
